import React, { useState } from "react";
import { Link } from "react-router-dom";
import successImage from "../assets/warranty image.png";

const WarrantySuccess = () => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      style={{
        minHeight: "70vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f5f7fa",
        padding: "20px",
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "15px",
          boxShadow: "0 4px 15px rgba(0,0,0,0.15)",
          padding: "30px",
          textAlign: "center",
          maxWidth: "600px",
          width: "100%",
        }}
      >
        <img
          src={successImage}
          alt="Warranty Success"
          style={{
            width: "100%",
            maxWidth: "450px",
            borderRadius: "10px",
            marginBottom: "25px",
          }}
        />

        <Link
          to="/"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          style={{
            display: "inline-block",
            background: isHovered ? "#0056b3" : "#0056b3",
            color: "#fff",
            textDecoration: "none",
            padding: "10px 20px",
            fontSize: "16px",
            borderRadius: "8px",
            transition: "background 0.3s ease",
            fontWeight: "600",
          }}
        >
          ⬅ Go Back to Home
        </Link>
      </div>
    </div>
  );
};

export default WarrantySuccess;